import { doesStrMatches } from './utils';

const noHeaderPaths = [
  '/implicit/callback',
  '/landing',
  '/partners',
  '/onboarding((?!thanks).)*$',
  '/import-contacts',
  '/send-swag',
  '/ship-swag/',
  '/orders-requested/\\d+/\\w+-\\w+',
  '/reorder/select-products',
  '/reorder/select-quantities'
];

const isAllowed = pathname => !doesStrMatches(pathname, noHeaderPaths);

export { isAllowed };
